import { translations } from '../trans';

export default function i18nt() {
  var text = translations[document.getElementsByTagName('html')[0].getAttribute('lang')]['frontend'][arguments[0]];

  return text === undefined ? arguments[0] : text;
};

